import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpBaseUrlInterceptor } from '@app/core/interceptors/http-base-url-interceptor.service';
import { LoadingBarInterceptor } from '@app/core/interceptors/loading-bar-interceptor';
import { CommitIdInterceptor } from '@app/core/interceptors/commit-id-interceptor';
import { SourceInterceptor } from '@app/core/interceptors/source-interceptor';
import { BlobErrorHttpInterceptor } from '@app/core/interceptors/blob-http-interceptor';
import { LocaleInterceptor } from '@app/core/interceptors/locale.interceptor';

export const INTERCEPTORS_PROVIDERS: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpBaseUrlInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoadingBarInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CommitIdInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SourceInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BlobErrorHttpInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: LocaleInterceptor, multi: true },
];
